"use client";

import { Row } from "@faire/web/slate/Layout";
import React from "react";

export const CondensedBrandHeaderDropdownListItem = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  return (
    <Row
      className="bg-core-surface-inverse w-full"
      gap="2x"
      align="center"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick?.();
      }}
    >
      {children}
    </Row>
  );
};
